/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScreenerSourceAllowName
 */
export interface ScreenerSourceAllowName {
    /**
     * 
     * @type {string}
     * @memberof ScreenerSourceAllowName
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerSourceAllowName
     */
    organization_id: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerSourceAllowName
     */
    facility_id: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerSourceAllowName
     */
    integration_type: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerSourceAllowName
     */
    source_name: string;
}

/**
 * Check if a given object implements the ScreenerSourceAllowName interface.
 */
export function instanceOfScreenerSourceAllowName(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "organization_id" in value;
    isInstance = isInstance && "facility_id" in value;
    isInstance = isInstance && "integration_type" in value;
    isInstance = isInstance && "source_name" in value;

    return isInstance;
}

export function ScreenerSourceAllowNameFromJSON(json: any): ScreenerSourceAllowName {
    return ScreenerSourceAllowNameFromJSONTyped(json, false);
}

export function ScreenerSourceAllowNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerSourceAllowName {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organization_id': json['organization_id'],
        'facility_id': json['facility_id'],
        'integration_type': json['integration_type'],
        'source_name': json['source_name'],
    };
}

export function ScreenerSourceAllowNameToJSON(value?: ScreenerSourceAllowName | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'organization_id': value.organization_id,
        'facility_id': value.facility_id,
        'integration_type': value.integration_type,
        'source_name': value.source_name,
    };
}

